import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { PriceLevel } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class PriceLevelService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getPriceLevel(id, schema = { id: null }): Promise<PriceLevel> {
    return new PriceLevel(await this.core.services.priceLevel.getById(id, schema))
  }

  async getPriceLevels(
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: PriceLevel[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.priceLevel.getList(parameters, schema)
  }

  createPriceLevel(priceLevel: Partial<PriceLevel>, schema: Partial<PriceLevel>): Promise<PriceLevel> {
    return this.core.services.priceLevel.create(priceLevel, schema)
  }

  updatePriceLevel(priceLevel: Partial<PriceLevel>, schema: Partial<PriceLevel>): Promise<PriceLevel> {
    return this.core.services.priceLevel.update(priceLevel, schema)
  }

  deletePriceLevel(priceLevel: Partial<PriceLevel>): Promise<PriceLevel> {
    return this.core.services.priceLevel.delete(priceLevel)
  }
}
